var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-text-btn',_vm._g(_vm._b({class:( _obj = { 'link-btn': true }, _obj[("link-btn--" + _vm.variant)] = _vm.variant, _obj ),attrs:{"variant":_vm.variant}},'app-text-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }